interface DiagnosticClient {
  ready(): void;
  stage(name: string): void;
  captureError(error: unknown, context?: { operation?: string }): void;
  breadcrumb(name: string): void;
  getId(): string | null;
}
declare global {
  interface Window {
    __moyuDiagnostics?: DiagnosticClient;
  }
}
export function reportError(error: unknown, operation?: string) {
  try {
    window.__moyuDiagnostics?.captureError(error, { operation });
  } catch {}
}
